export const DATA_COLLECTION_ALL = 'DATA_COLLECTION_ALL';
export const DATA_COLLECTION_GLOBAL = 'DATA_COLLECTION_GLOBAL';
export const DATA_COLLECTION_USAGE = 'DATA_COLLECTION_USAGE';
export const DATA_COLLECTION_DIAGNOSTIC = 'DATA_COLLECTION_DIAGNOSTIC';
